import React from "react";
import { IconMoon, IconSun } from "./icons";
import { useTheme } from "../../context/ThemeContext";

/**
 * Light/dark mode toggle. The icon shows what will happen on click
 * (moon in light mode, sun in dark mode). Reads the global ThemeContext, so it is safe
 * to place anywhere (header, login screen).
 */
export default function ThemeToggle({ className = "" }) {
  const { darkMode, toggleTheme } = useTheme();
  const label = darkMode ? "Uključi svetli režim" : "Uključi tamni režim";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-slate-500 transition duration-150
        hover:bg-slate-100 hover:text-slate-900 active:translate-y-px
        dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-slate-50 ${className}`}
    >
      {darkMode ? <IconSun className="text-lg" aria-hidden="true" /> : <IconMoon className="text-lg" aria-hidden="true" />}
    </button>
  );
}
